import { clearAllCache } from '../composables/useQueryWithCache';
import { deleteTwCaches } from './serviceWorkerRegistration';

// Guest data written under `manifest_<slug>_<date>` by the removed localStorage day
// cache (TRIP-5064). Nothing writes these any more; this clears what devices still hold.
function purgeLegacyManifestDayCache() {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith('manifest_'))
      .forEach((k) => localStorage.removeItem(k));
  } catch (_e) {
    /* storage blocked (private mode) — nothing to purge */
  }
}

/**
 * Page-level purge of the sensitive client-side caches on logout, independent
 * of whether a service worker is registered (TRIP-4912 review).
 *
 * The `/logout` navigation's own worker-side purge (assets/sw/service-worker.js)
 * only runs for accounts with offline_mode's service worker registered. This
 * covers everyone else. Clears the IndexedDB query cache, the
 * worker's Cache Storage entries, and legacy `manifest_*` localStorage entries;
 * other localStorage (user preferences, printer selection) is left alone.
 *
 * Best-effort: never throws.
 */
export async function purgeQueryCacheOnLogout() {
  purgeLegacyManifestDayCache();
  await Promise.all([clearAllCache(), deleteTwCaches()]).catch(() => undefined);
}

// Runs on the page logout lands on (and on any signed-out page, e.g. after session
// expiry), so the logout click never waits on IndexedDB. `data-authenticated` is set by base.html.twig.
export function purgeIfSignedOut() {
  if (document.getElementById('app')?.dataset.authenticated !== 'false') return;
  purgeQueryCacheOnLogout();
}
